import { render, staticRenderFns } from "./NewsBrowser.vue?vue&type=template&id=32b00e34"
import script from "./NewsBrowser.vue?vue&type=script&lang=js"
export * from "./NewsBrowser.vue?vue&type=script&lang=js"
import style0 from "./NewsBrowser.vue?vue&type=style&index=0&id=32b00e34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports